module.exports = __webpack_public_path__ + "static/headz-up-logo-w-ca07de9ee3346bb00c57a0a0a9b2e73d.png";